export { default } from './ImageTextCover';
